import React from "react";

/**
 * Top-of-page lender strip. Uses uploaded SVG logos where available
 * and falls back to a styled branded wordmark for the rest.
 */
const LENDERS = [
    { name: "HSBC", file: "/lenders/hsbc.svg", color: "#DB0011" },
    { name: "Halifax", file: "/lenders/halifax.svg", color: "#005EB8" },
    { name: "NatWest", file: "/lenders/natwest.svg", color: "#5A287D" },
    { name: "Barclays", file: "/lenders/barclays.svg", color: "#00AEEF" },
    { name: "Santander", file: "/lenders/santander.svg", color: "#EC0000" },
    { name: "Nationwide", file: "/lenders/nationwide.svg", color: "#002466" },
    { name: "Virgin Money", file: "/lenders/virgin-money.svg", color: "#E10A0A" },
    { name: "Metro Bank", file: "/lenders/metro-bank.svg", color: "#1E3A8A" },
    { name: "TSB", file: "/lenders/tsb.svg", color: "#0B74BA" },
    { name: "Lloyds", file: "/lenders/lloyds.svg", color: "#006A4D" },
];

function LogoMark({ lender }) {
    const [err, setErr] = React.useState(false);

    if (lender.file && !err) {
        return (
            <div
                className="flex items-center justify-center h-14 md:h-12 px-5 md:px-7 shrink-0"
                title={lender.name}
                aria-label={lender.name}
            >
                <img
                    src={lender.file}
                    alt={lender.name}
                    onError={() => setErr(true)}
                    loading="lazy"
                    className="h-10 md:h-9 w-auto max-w-[190px] md:max-w-[170px] object-contain"
                    style={{ imageRendering: "-webkit-optimize-contrast" }}
                />
            </div>
        );
    }

    return (
        <div
            className="flex items-center justify-center h-12 px-7 shrink-0"
            title={lender.name}
            aria-label={lender.name}
        >
            <span
                className="text-[17px] font-extrabold tracking-tight whitespace-nowrap"
                style={{
                    color: lender.color,
                    fontFamily: "Manrope, Inter, system-ui, sans-serif",
                    letterSpacing: "-0.02em",
                }}
            >
                {lender.name}
            </span>
        </div>
    );
}

export default function LenderMarquee() {
    return (
        <section
            data-testid="lender-marquee"
            aria-label="Lenders we work with"
            className="relative bg-brand-surface border-b border-brand-border overflow-hidden"
        >
            <div className="relative flex items-center">
                <div className="shrink-0 flex items-center gap-2 px-4 md:px-6 py-3 bg-brand-primary text-white z-10">
                    <span className="h-2 w-2 rounded-full bg-brand-coral animate-pulse shrink-0" />
                    <span className="text-[9px] md:text-[10px] uppercase tracking-[0.18em] md:tracking-[0.22em] font-bold whitespace-nowrap">
                        <span className="hidden sm:inline">Working with </span>90+ UK lenders
                    </span>
                </div>

                <div className="relative flex-1 overflow-hidden">
                    <div
                        aria-hidden="true"
                        className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-brand-surface to-transparent z-10"
                    />
                    <div
                        aria-hidden="true"
                        className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-brand-surface to-transparent z-10"
                    />
                    <div className="marquee-track flex items-center whitespace-nowrap py-2">
                        {[...LENDERS, ...LENDERS].map((l, i) => (
                            <LogoMark key={i} lender={l} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
